import { useTranslation } from 'react-i18next';
import { Progress } from '@/components/ui/progress';
import { Loader2 } from 'lucide-react';

interface ImportProgressBarProps {
  progress: number;
  current: number;
  total: number;
}

export function ImportProgressBar({ progress, current, total }: ImportProgressBarProps) {
  const { t } = useTranslation(['clients']);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-center gap-3">
        <Loader2 className="h-5 w-5 animate-spin text-primary" />
        <span className="text-sm font-medium">
          {t('import.progress.processing', { current, total })}
        </span>
      </div>
      
      <Progress value={progress} className="h-2" />
      
      <p className="text-center text-xs text-muted-foreground">
        {t('import.progress.hint')}
      </p>
    </div>
  );
}
